/* Built In Imports */
/* External Imports */
import { Center } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import React from 'react';
/* Internal Imports */
/* Components */
import StructuredTextParser from '@shi/Utility/StructuredTextParser';
/* Styles */
/* Services */

/**
 *
 * @param {Obj} sectionContent
 * @param {Str} region
 * @param {Str} lang
 * @returns {ReactElement} BrownBgInfo
 */
const BrownBgInfo = ({ sectionContent, region, lang }) => {
  return (
    <Center bg="#4C0000" py={{ base: '7px', md: '20px' }} height="68px">
      <StructuredTextParser
        textAlign="center"
        maxW="auto"
        mx="auto"
        bgTheme="light"
        fontFamily="FedraSansStd-medium"
        mt="0"
        px="15px"
        sx={{
          p: {
            margin: 'auto',
            fontFamily: 'FedraSansStd-medium !important',
            position: 'relative',
            fontSize: { base: '16px', md: '18px' },
            textAlign: { base: 'left', md: 'center' },
            paddingLeft: { base: '40px', md: '30px', lg: '35px' },
          },
          'p::before': {
            content: "'!'",
            width: '25px',
            height: '25px',
            bg: '#fff',
            position: 'absolute',
            zIndex: '5',
            display: 'inline-flex',
            rounded: 'full',
            color: '#4C0000',
            fontSize: '18px',
            transform: 'rotate(180deg)',
            fontFamily: 'FedraSansStd-medium',
            alignItems: 'center',
            justifyContent: 'center',
            top: { base: '7px', sm: '0' },
            left: 0,
          },
        }}
        str={render(sectionContent?.[0]?.body)}
      />
    </Center>
  );
};

export default BrownBgInfo;
